(function () {
  function init(root) {
    if (!root || root.dataset.nvReady) return;
    root.dataset.nvReady = 'true';

    const stageItems = [...root.querySelectorAll('[data-nv-media]')];
    root.querySelectorAll('[data-nv-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const target = thumb.dataset.nvThumb;
        root.querySelectorAll('[data-nv-thumb]').forEach((item) => item.setAttribute('aria-current', String(item === thumb)));
        stageItems.forEach((item) => {
          item.classList.toggle('is-active', item.dataset.nvMedia === target);
          if (item.tagName === 'VIDEO' && item.dataset.nvMedia !== target) item.pause();
        });
      });
    });

    const quantity = root.querySelector('[data-nv-quantity]');
    root.querySelectorAll('[data-nv-offer]').forEach((offer) => {
      offer.addEventListener('click', () => {
        root.querySelectorAll('[data-nv-offer]').forEach((item) => item.classList.remove('is-active'));
        offer.classList.add('is-active');
        const radio = offer.querySelector('input[type="radio"]');
        if (radio) radio.checked = true;
        if (quantity) quantity.value = offer.dataset.quantity || '1';
      });
    });

    root.querySelectorAll('[data-nv-scroll-offers]').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const target = root.querySelector('[data-nv-offers-target]');
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
          target.focus({ preventScroll: true });
        }
      });
    });

    root.querySelectorAll('[data-nv-delivery-estimate]').forEach((estimate) => {
      const months = ['ian.', 'feb.', 'mart.', 'apr.', 'mai', 'iun.', 'iul.', 'aug.', 'sept.', 'oct.', 'nov.', 'dec.'];
      const today = new Date();
      const addBusinessDays = (date, count) => {
        const result = new Date(date);
        let added = 0;
        while (added < count) {
          result.setDate(result.getDate() + 1);
          if (result.getDay() !== 0 && result.getDay() !== 6) added += 1;
        }
        return result;
      };
      const formatDate = (date) => `${String(date.getDate()).padStart(2, '0')} ${months[date.getMonth()]}`;
      const firstDay = addBusinessDays(today, 1);
      const secondDay = addBusinessDays(today, 2);
      const orderDate = estimate.querySelector('[data-nv-order-date]');
      const deliveryRange = estimate.querySelector('[data-nv-delivery-range]');
      if (orderDate) orderDate.textContent = formatDate(today);
      if (deliveryRange) {
        deliveryRange.textContent = firstDay.getMonth() === secondDay.getMonth()
          ? `${String(firstDay.getDate()).padStart(2, '0')}–${formatDate(secondDay)}`
          : `${formatDate(firstDay)} – ${formatDate(secondDay)}`;
      }
    });

    root.querySelectorAll('[data-nv-compare]').forEach((compare) => {
      const range = compare.querySelector('input[type="range"]');
      if (!range) return;
      const update = () => compare.style.setProperty('--nv-pos', `${range.value}%`);
      range.addEventListener('input', update);
      update();
    });

    const focusTitle = root.querySelector('[data-nv-focus-title]');
    const focusText = root.querySelector('[data-nv-focus-text]');
    const focusIndex = root.querySelector('[data-nv-focus-index]');
    const focusButtons = [...root.querySelectorAll('[data-nv-focus]')];
    focusButtons.forEach((button) => {
      button.addEventListener('click', () => {
        focusButtons.forEach((item) => item.classList.toggle('is-active', item === button));
        if (focusTitle) focusTitle.textContent = button.dataset.title;
        if (focusText) focusText.textContent = button.dataset.text;
        if (focusIndex) focusIndex.textContent = button.dataset.index;
      });
    });

    const choiceTitle = root.querySelector('[data-nv-choice-title]');
    const choiceText = root.querySelector('[data-nv-choice-text]');
    const choiceButtons = [...root.querySelectorAll('[data-nv-choice]')];
    choiceButtons.forEach((button) => {
      button.addEventListener('click', () => {
        choiceButtons.forEach((item) => item.classList.toggle('is-active', item === button));
        if (choiceTitle) choiceTitle.textContent = button.dataset.title;
        if (choiceText) choiceText.textContent = button.dataset.text;
      });
    });

    root.querySelectorAll('[data-nv-reviews]').forEach((reviews) => {
      const track = reviews.querySelector('[data-nv-review-track]');
      if (!track) return;
      const move = (direction) => {
        const card = track.querySelector('.nv-review-card');
        const distance = card ? card.getBoundingClientRect().width + 16 : track.clientWidth * 0.85;
        track.scrollBy({ left: direction * distance, behavior: 'smooth' });
      };
      reviews.querySelector('[data-nv-review-prev]')?.addEventListener('click', () => move(-1));
      reviews.querySelector('[data-nv-review-next]')?.addEventListener('click', () => move(1));
    });

    const revealItems = root.querySelectorAll('.nv-section-head,.nv-feature,.nv-detail-grid,.nv-gift-card,.nv-compare-head,.nv-beforeafter,.nv-focus-grid,.nv-choice-grid,.nv-table-wrap,.nv-family-overlay,.nv-review-card');
    revealItems.forEach((item) => item.setAttribute('data-nv-reveal', ''));
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
      }), { threshold: 0.12 });
      revealItems.forEach((item) => observer.observe(item));
    } else revealItems.forEach((item) => item.classList.add('is-visible'));
  }

  document.querySelectorAll('[data-nv-section]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-nv-section]')));
})();
